import { doc, getDoc } from "@firebase/firestore";
import { showWarningSnackbar } from "../../../../../../../shared/snackbar/snackbar-slice";
import { hideLoading, showItemInformationDialog, showLoading } from "./item-information-list-slice";

export const getItemDetailsDataService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            dispatch(showItemInformationDialog(docSnap.data()));
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        console.error("ItemTabs getItemDetailsDataService error: ", e);
    }
    finally {
        // This block will always execute, even if there's an exception
        dispatch(hideLoading()); // Make sure this is here
    }
};